<div class="dialog">
  <mat-dialog-content>
    <div class="video-container">
      <iframe frameborder="0" allowfullscreen [src]='data.video'></iframe>
    </div>
  </mat-dialog-content>

</div>